const translations = {
    hold: 'Hold'
};

export default translations;
